import {
    cookieConsentService,
} from "../../services/cookie-consent.service";

const themeCookieName = "theme";

function getThemeRoot() {
    if (typeof document === "undefined") {
        return null;
    }

    return document.querySelector(".theme");
}

export const browserThemePreference = Object.freeze({
    read() {
        return cookieConsentService.getFunctionalCookie(
            themeCookieName
        );
    },

    save(theme) {
        cookieConsentService.setFunctionalCookie(
            themeCookieName,
            theme
        );
    },

    apply(theme) {
        const themeRoot = getThemeRoot();

        if (!themeRoot) {
            return;
        }

        themeRoot.classList.toggle(
            "theme--dark",
            theme === "dark"
        );
    },
});
